import {useCallback, useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useNavigate, useParams} from 'react-router-dom';

import PrimaryCard from '../../../components/mazraeKit/cards/primaryCard';
import CustomPaginate from '../../../components/mazraeKit/customPaginate';
import CustomSearchBox from '../../../components/mazraeKit/customSearchBox';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import {RootState} from '../../../store/redux';
import useDebounce from '../../../utilities/hooks/useDebounce/useDebounce';

import classNames from 'classnames';
import DotsLoading from '../../../components/dotsLoading';
import NoItemFoundPage from '../../../components/noItemFoundPage';
import useGetAdverisements from '../../../services/hookService/getAdvertisements/useGetAdverisements';
import UseGetProfileCity from '../../../services/hookService/getProfileCityName/useGetProfileCity';
import {addingFilterInputGuid} from '../../../store/redux/inputGroupAdvertisement';
import {CodeToInputGroupName} from '../../../utilities/helper/codeToInputGroupName';
import useScrolling from '../../../utilities/hooks/useScrolling/useScrolling';
import InputPostListBottomSheet from '../advertisementList/advertisementListBottomSheet';
import {
  GroupNameToInputName,
  InputNameToCode,
} from '../advertisementList/utils';
import {useAdvertisementFilters} from '../../../hooks/filters/useAdvertisementFilter';
import FiltersAdvertisementList from '../advertisementList/advertisementListBottomSheet/FiltersAdvertisementList/FilterAdvertisementList';

const PER_PAGE_SIZE = 7;

const AdvertisementListForAll = () => {
  const location = useLocation();
  const observer = useRef<IntersectionObserver | null>(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {state: locationState} = useLocation();
  const scrollDivElement = useRef<HTMLDivElement | null>(null);
  const {isScrollingDown, setIsScrollingDown} = useScrolling(scrollDivElement);
  const {filters, setFilter} = useAdvertisementFilters();
  useEffect(() => {
    if (locationState?.selectedInput) {
      dispatch(addingFilterInputGuid([locationState.selectedInput]));
    }
  }, [locationState]);

  const {inputGroupName} = useParams();

  const {state: stateParams} = useLocation();
  const [currentPage, setCurrentPage] = useState(1);

  const [inputValue, setInputValue] = useState<string>(
    stateParams?.searchText || '',
  );
  const [openBottomSheet, setOpenBottomSheet] = useState(false);

  const debouncedValue = useDebounce(inputValue, 2000);
  useEffect(() => {
    setFilter('search', debouncedValue);
  }, [debouncedValue]);

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };
  const {locational} = useSelector(
    (state: RootState) => state.searchingLocation,
  );
  const cities = locational.map(item => item.id).toString();
  const {advertisementList, isLoading} = useGetAdverisements({
    search: filters.search || undefined,
    selected_cities_id: cities || undefined,
    page: currentPage,
    page_size: PER_PAGE_SIZE,
    ordering: filters?.order_by || undefined,
    input_groups_guid: filters.input_group_guid.length
      ? filters.input_group_guid.map(item => item.guid).join(',')
      : undefined,
    has_store: filters?.has_store || undefined,
    has_price: filters?.has_price || undefined,
    start_price: filters?.start_price || undefined,
    end_price: filters?.end_price || undefined,
    has_immediate: filters?.has_immediate || undefined,
    has_special_offer: filters?.has_special_offer || undefined,
  });
  const lastElementChat = useCallback((node: HTMLDivElement) => {
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        setIsScrollingDown(false);
      }
    });
    if (node) observer.current.observe(node);
  }, []);
  return (
    <div className="flex relative flex-col w-full h-dvh">
      <div>
        <CustomHeader
          canScroll={true}
          isScrolling={false}
          title="جدیدترین آگهی‌ها"
          preIcon="icon-nameArrow---Right"
          isActiveRightIcon
          onClick={() => {
            navigate(locationState?.pathname ?? '/home');
          }}
        />
      </div>
      <div
        className={classNames(
          'overflow-y-hidden px-3 my-3 w-full duration-500 ease-in-out',
          {
            'h-0 opacity-0': isScrollingDown,
            'h-52 opacity-100': !isScrollingDown,
          },
        )}
      >
        <CustomSearchBox
          placeholder="جستجو در آگهی ها  "
          type="text"
          value={inputValue}
          inputCustomClass="!pr-8"
          isFloating={false}
          preIcon="icon-nameSearch"
          removeIconClassName="!left-20"
          onChange={onChangeHandler}
          customComponent={() => (
            <div
              className="flex absolute left-0 top-1/2 items-center px-2 py-2 border-r-2 border-gray-100 -translate-y-1/2"
              onClick={() =>
                navigate('/choose-location', {
                  state: {from: location?.pathname},
                })
              }
            >
              <i className="text-xl icon-nameLocation" />
              <span
                className="text-sm"
                onClick={() =>
                  navigate('/choose-location', {
                    state: {from: location?.pathname},
                  })
                }
              >
                {locational?.length
                  ? `${locational?.length} شهرستان`
                  : UseGetProfileCity().profileCity}
              </span>
            </div>
          )}
          {...{inputValue, setInputValue}}
        />
        <div className="flex overflow-x-auto gap-2 items-center mt-3 w-full">
          <button
            className="flex gap-2 items-center px-3 py-2 text-gray-700 rounded-full border w-fit"
            onClick={() => setOpenBottomSheet(true)}
          >
            <i className="font-bold icon-nameFilter text-xxl" />
            <span className="text-sm whitespace-nowrap">فیلتر کردن</span>
          </button>
          <div>
            <FiltersAdvertisementList inputGroupName={inputGroupName} />
          </div>
        </div>
      </div>
      <section
        className="flex overflow-y-auto flex-col gap-4 px-3 h-full"
        ref={scrollDivElement}
      >
        {isLoading && <DotsLoading />}
        {!isLoading && !!!advertisementList?.results.length && (
          <NoItemFoundPage />
        )}
        {advertisementList?.results.map(
          (item: IInputGroupsAdvertisementResults, index: number) => (
            <PrimaryCard
              {...item}
              cardSize="lg"
              onClick={() =>
                navigate(
                  `/category-card-detail/${
                    CodeToInputGroupName[item.input_group?.code]
                  }/${item.id}`,
                )
              }
            />
          ),
        )}
        <div ref={lastElementChat} />
      </section>

      <div
        className={classNames('duration-500 ease-in-out', {
          'overflow-y-hidden my-2 h-0 opacity-0': isScrollingDown,
          'my-3 opacity-100': !isScrollingDown,
        })}
      >
        {advertisementList?.results && (
          <CustomPaginate
            currentPage={currentPage}
            onPageChange={setCurrentPage}
            totalCount={advertisementList?.count}
            perPageSize={PER_PAGE_SIZE}
          />
        )}
      </div>

      <InputPostListBottomSheet
        openBottomSheet={openBottomSheet}
        setOpenBottomSheet={setOpenBottomSheet}
        code={inputGroupName ? InputNameToCode[inputGroupName] : undefined}
        title={inputGroupName && GroupNameToInputName[inputGroupName]}
        isShowType={false}
        isCategoriesPage={false}
      />
      <MainFooter isScrolling={false} />
    </div>
  );
};

export default AdvertisementListForAll;
